<template>
  <div class="bg-white p-4 rounded-lg shadow-md flex gap-4 relative">
    <!-- Toggle Arrow Button -->
    <button
        @click="toggleDescription"
        class="absolute left-2 top-[60px] transform -translate-y-1/2 ml-10 focus:outline-none hover:cursor-pointer"
        style="height: 24px;"
    >
      <svg
          :class="{'rotate-180': isExpanded}"
          class="w-6 h-6 text-blue-500 transition-transform duration-300"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
      >
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
      </svg>
    </button>

    <img :src="course.course_image_url" alt="Course Image" class="w-20 h-20 rounded"/>
    <div class="flex-1 ml-6">
      <span v-if="course.course_type_text" class="bg-[#999] text-white text-xs font-semibold px-2 py-1 rounded-full">
        {{ course.course_type_text }}
      </span>
        <div v-else class="h-5">

        </div>

      <h3 class="text-lg font-semibold m-auto">{{ course.course_name }}</h3>
      <p class="text-gray-600">
        <span v-if="course.details_type">
            {{ course.details_type }}
          </span>
          <span v-if="course.details_type">
            |
          </span>
          <span v-if="course.effort">
            الجهد المقدر: {{ course.effort || 0 }}
          </span>
      </p>
      <br>
      <div v-if="isExpanded">
        <hr class="custom-hr">
        <h4 class="text-md font-bold mt-5">وصف الدورة:</h4>
        <p  class="text-sm text-gray-500 mt-2">
          {{ course.course_description }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    course: Object,
  },
  data() {
    return {
      isExpanded: false,
    };
  },
  methods: {
    toggleDescription() {
      this.isExpanded = !this.isExpanded;
    },
  },
};
</script>

<style scoped>
.rotate-180 {
  transform: rotate(180deg);
}

.custom-hr {
  border-color: #999;
}
</style>